import 'normalize.css';
import './main'